<div class="mat-h3">
  Debitoren-Konten
</div>
<ul>
  <li>
    <div class="mat-h4">
      Debitor-Konto Divers
    </div>
    <p>
      Dieses Debitoren-Konto wird für Privatpatienten verwendet. Es dient der Erfassung der entsprechenden Kontonummer
      für die Abrechnung privater Leistungen.
    </p>
  </li>
  <li>
    <div class="mat-h4">
      Debitor-Konto Sepa
    </div>
    <p>
      Dieses Debitoren-Konto wird für Leistungen verwendet, bei denen die Rechnung über Sepa eingezogen wird und kein
      Debitor-Konto am Leistungsempfänger hinterlegt ist.
    </p>
  </li>
  <li>
    <div class="mat-h4">
      Debitor-Konto Unbekannt
    </div>
    <p>
      Dieses Debitoren-Konto wird genutzt, wenn keine spezifische Kontonummer für den Debitor verfügbar ist. Es stellt
      sicher, dass auch in solchen Fällen eine korrekte Erfassung der Transaktion erfolgt.
    </p>
  </li>
</ul>
